// extracted by mini-css-extract-plugin
export default {"form_send_page":"sendRequest_form_send_page__LBhlf","form_send_page_title":"sendRequest_form_send_page_title__2lHCB","form_send_page_about":"sendRequest_form_send_page_about__y4rd1"};